import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Async thunk to fetch companies
export const fetchCompanies = createAsyncThunk("companies/fetch", async () => {
  const response = await fetch("https://api.terraweb.africa/getcompanies");
  const data = await response.json();
  return data;
});

const companySlice = createSlice({
  name: "companies",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default companySlice.reducer;
